import * as React from 'react';
import { NavigatorButton as NavigatorButtonMemoized } from './components/NavigatorButton.js';
import { NavigatorLayout as NavigatorLayoutMemoized } from './components/NavigatorLayout.js';

/**
 * INTERNAL component for navigating in an overflowing container.
 */
var Navigator = function Navigator(props) {
  return /*#__PURE__*/React.createElement(NavigatorLayoutMemoized, props, /*#__PURE__*/React.createElement(NavigatorButtonMemoized, props));
};
var NavigatorMemoized = /*#__PURE__*/React.memo(Navigator);
NavigatorMemoized.displayName = 'Navigator';

export { NavigatorMemoized as Navigator };
//# sourceMappingURL=Navigator.js.map
